import { store } from '@/decorators/store';
import { Nature } from '@/entities/Nature';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'Nature' })
export class NatureStore extends AbstractEntityStore<Nature> {
  protected entityIdKey = 'id';
  protected entityLabelKey = 'value';
  protected entityValueKey = 'value';
}
